import { TableColumn } from "react-data-table-component";
import TableMenu from "@/components/shared/TableMenu";

export const userColumns = (
  setSelectedUser: React.Dispatch<React.SetStateAction<any>>,
  setShowEdit: React.Dispatch<React.SetStateAction<boolean>>,
  setShowView: React.Dispatch<React.SetStateAction<boolean>>,
  setShowResetPassword: React.Dispatch<React.SetStateAction<boolean>>
) =>
  [
    {
      name: "ID",
      selector: (row: any) => row.id,
      grow: 2,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row: any) => row.name,
      grow: 2,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row: any) => row.email,
      grow: 2,
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row: any) => row.phone,
      grow: 2,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row: any) => row.role,
      grow: 2,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row: any) => row.status,
      cell: (row: any) => (
        <span
          className={`
        py-1 px-3 border-round
        bg-${row.status === "Active" ? "green" : "red"}-100
        text-${row.status === "Active" ? "green" : "red"}-600
        `}
        >
          {row.status}
        </span>
      ),
      grow: 2,
      sortable: true,
    },
    {
      selector: (row: any) => row.id,
      grow: 1,
      center: true,
      cell: (row: any) => (
        <TableMenu
          menuType="viewEditReset"
          onView={() => {
            setSelectedUser(row);
            setShowView(true);
            setShowEdit(false);
            setShowResetPassword(false);
          }}
          onEdit={() => {
            setSelectedUser(row);
            setShowEdit(true);
            setShowView(false);
            setShowResetPassword(false);
          }}
          onReset={() => {
            setSelectedUser(row);
            setShowResetPassword(true);
            setShowEdit(false);
            setShowView(false);
          }}
        />
      ),
    },
  ] as TableColumn<any>[];

export const roleColumns = () =>
  [
    {
      name: "ID",
      selector: (row: any) => row.id,
      grow: 2,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row: any) => row.name,
      grow: 2,
      sortable: true,
    },
    {
      name: "Assigned",
      selector: (row: any) => row.assigned,
      grow: 2,
      sortable: true,
    },
  ] as TableColumn<any>[];

export const productColumns = () =>
  [
    {
      name: "ID",
      selector: (row: any) => row.id,
      grow: 2,
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row: any) => row.name,
      grow: 2,
      sortable: true,
    },
    {
      name: "Assigned Traceability Flow",
      selector: (row: any) => row.assigned_traceability,
      grow: 2,
      sortable: true,
    },
  ] as TableColumn<any>[];

export const flowColumns = () =>
  [
    {
      name: "ID",
      selector: (row: any) => row.id,
      grow: 2,
      sortable: true,
    },
    {
      name: "Flow Name",
      selector: (row: any) => row.name,
      grow: 2,
      sortable: true,
    },
    {
      name: "Observers",
      selector: (row: any) => row.observers?.length,
      grow: 2,
      sortable: true,
    },
    {
      name: "Product",
      selector: (row: any) => row.product,
      grow: 2,
      sortable: true,
    },
  ] as TableColumn<any>[];

export const cteColumns = () =>
  [
    {
      name: "ID",
      selector: (row: any) => row.id,
      grow: 2,
      sortable: true,
    },
    {
      name: "CTE Name",
      selector: (row: any) => row.name,
      grow: 2,
      sortable: true,
    },
    {
      name: "Assigned KDE",
      selector: (row: any) => row.assigned_kdes?.length,
      grow: 2,
      sortable: true,
    },
    {
      name: "Assigned Users",
      selector: (row: any) => row.assigned_users?.length,
      grow: 2,
      sortable: true,
    },
  ] as TableColumn<any>[];

export const historyColumns = () =>
  [
    {
      name: "Batch Number",
      selector: (row: any) => row.batch_number,
      grow: 2,
      sortable: true,
    },
    {
      name: "Product",
      selector: (row: any) => row.product,
      grow: 2,
      sortable: true,
    },
    {
      name: "Flow",
      selector: (row: any) => row.flow,
      grow: 2,
      sortable: true,
    },

    {
      name: "Date",
      selector: (row: any) => row.date,
      grow: 2,
      sortable: true,
    },
  ] as TableColumn<any>[];

export const trackingColumns = () =>
  [
    {
      name: "Batch Number",
      selector: (row: any) => row.batch_number,
      grow: 2,
      sortable: true,
    },
    {
      name: "Product",
      selector: (row: any) => row.product,
      grow: 2,
      sortable: true,
    },
    {
      name: "Flow",
      selector: (row: any) => row.flow,
      grow: 2,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row: any) => row.date,
      grow: 2,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row: any) => row.status,
      grow: 2,
      sortable: true,
    },
  ] as TableColumn<any>[];
